import { render } from "./crossChain_1.vue?vue&type=template&id=c43c59c8&scoped=true&lang=pug"
import script from "./crossChain_1.vue?vue&type=script&setup=true&lang=js"
export * from "./crossChain_1.vue?vue&type=script&setup=true&lang=js"

import "./crossChain_1.vue?vue&type=style&index=0&id=c43c59c8&scoped=true&lang=css"

import exportComponent from "/Users/liu/Downloads/开发程序/bridge v2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c43c59c8"]])

export default __exports__